import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import CustomTabs from "../../components/Tab";
import InputBox from "../../components/InputBox";
import Dropdown from "../../components/Dropdown";
import SelectDropDown from "../../components/SelectDropDown";
import DupontDatePicker from "../../components/DatePopover/DupontDatePicker";
import { DatePickerConfig } from "../../components/DatePopover/DateTimeConfig";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";

import "./index.scss";

const RoConfiguration = ({
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  setStageValidationSucessfull,
  noOfTrains,
}) => {
  const { t, i18n } = useTranslation();
  const [trainobj, setTrainObj] = useState(trains);

  const [traintabs, setTraintabs] = useState([]);
  const [selectedTrain, setSelectedTrain] = useState(0);
  const [selectedTrainPage, setSelectedTrainPage] = useState(null);

  useEffect(() => {
    if (trains && Object.keys(trains).length >= 1) {
      setTrainObj(Object.values(trains));
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    if (noOfTrains === "" || noOfTrains === undefined || noOfTrains === "0") {
      return;
    }

    if (trainobj.length > noOfTrains) {
      for (let i = trainobj.length; i > noOfTrains; i--) {
        trainobj.pop(i - 1);
      }
    }
    var start = trainobj === undefined ? 0 : Object.keys(trainobj).length;
    for (let i = start + 1; i <= parseInt(noOfTrains); i++) {
      const newTrain = {
        train_id: i,
        passes: [{ pass_id: 1, stages: [{ stage_id: 1 }] }],
      };
      trainobj.push(newTrain);
    }

    for (let i = 1; i <= parseInt(noOfTrains); i++) {
      tabs.push({
        label: `${t("addNewPlant.train")} ${i}`,
        tabval: `${t("addNewPlant.train")} ${i}`,
        page: (
          <PassComponent
            train_id={i}
            t={t}
            trains={trainobj}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
          />
        ),
      });
    }
    setTrains({ ...trainobj });
    setTraintabs(tabs);
    if (tabs && tabs.length && tabs.length > selectedTrain) {
      setSelectedTrainPage(tabs[selectedTrain]?.page);
    } else {
      setSelectedTrain(0);
      setSelectedTrainPage(tabs[0]?.page);
    }
  }, [noOfTrains, trainobj, stageValidationSucessfull, t]);

  const onTrainTabSelected = (value) => {
    setSelectedTrainPage(traintabs[value].page);
    setSelectedTrain(value);
  };

  return (
    <>
      <div className="flex-between outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfTrains")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <InputBox
          id="no-of-trains"
          name="trains"
          value={noOfTrains}
          customClass="custom-input-width "
          placeholder={t("addNewPlant.noOfTrains")}
          disabled
          hideClearBtn
        />
      </div>
      {traintabs && (
        <>
          <div className="horizontal-scroll-container">
            <div className="horizontal-scroll">
              <CustomTabs
                tabOptions={traintabs}
                tabChangeHandler={onTrainTabSelected}
                value={selectedTrain}
              />
            </div>
          </div>
          <div>{selectedTrainPage}</div>
        </>
      )}
    </>
  );
};

export default RoConfiguration;

const passOptions = () => {
  return ["1", "2", "3"];
};
export const PassComponent = ({
  train_id,
  t,
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  setStageValidationSucessfull,
}) => {
  const passOption = passOptions();
  train_id -= 1;
  const [pass, setPass] = useState(trains[train_id].passes.length);
  const [passtabs, setPasstabs] = useState([]);
  const [selectedPass, setSelectedPass] = useState(0);
  const [selectedPassPage, setSelectedPassPage] = useState(null);
  const passNo =
    trains[train_id]?.passes?.length <= 0
      ? 1
      : trains[train_id]?.passes?.length;

  useEffect(() => {
    setPass(trains[train_id].passes.length);
  }, [trains[train_id].passes.length, t]);

  useEffect(() => {
    if (trains && trains[train_id].passes.length >= 1) {
      setPass(trains[train_id].passes.length);
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    for (let i = 1; i <= passNo; i++) {
      tabs.push({
        label: `${t("addNewPlant.pass")} ${i}`,
        tabval: `${t("addNewPlant.pass")} ${i}`,
        page: (
          <StageComponent
            train_id={train_id}
            pass_id={i}
            t={t}
            trains={trains}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
          />
        ),
      });
    }
    setPasstabs(tabs);

    if (tabs && tabs.length > 0 && tabs[selectedPass]) {
      setSelectedPassPage(tabs[selectedPass].page);
    } else {
      setSelectedPassPage(tabs[0].page);
      setSelectedPass(0);
    }
  }, [trains, t]);

  useEffect(() => {
    const tabs = [];
    for (let i = 1; i <= passNo; i++) {
      tabs.push({
        label: `${t("addNewPlant.pass")} ${i}`,
        tabval: `${t("addNewPlant.pass")} ${i}`,
        page: (
          <StageComponent
            train_id={train_id}
            pass_id={i}
            t={t}
            trains={trains}
            setTrains={setTrains}
            setTotalNumberOfElements={setTotalNumberOfElements}
            stageValidationSucessfull={stageValidationSucessfull}
            setStageValidationSucessfull={setStageValidationSucessfull}
          />
        ),
      });
    }

    setPasstabs(tabs);

    if (tabs && tabs.length > 0 && tabs[selectedPass]) {
      setSelectedPassPage(tabs[selectedPass].page);
    } else {
      setSelectedPassPage(tabs[0].page);
      setSelectedPass(0);
    }
  }, [pass, passNo, stageValidationSucessfull, t]);

  const onPassChanged = (value) => {
    var start = trains[train_id]?.passes?.length;
    start = start ? start : 1;

    if (start > value) {
      for (let i = start; i > value; i--) {
        trains[train_id].passes.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(value); i++) {
      const newPass = {
        pass_id: i,
        stages: [
          {
            stage_id: 1,
          },
        ],
      };
      trains[train_id].passes.push(newPass);
    }
    setPass(value);
    setTrains({ ...trains });
  };
  const onPassTabSelected = (value) => {
    setSelectedPassPage(passtabs[value].page);
    setSelectedPass(value);
  };

  return (
    <>
      <div className="flex-between outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfPass")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <div className="custom-input-width">
          <Dropdown
            id="no-of-passes"
            placeholder={t("addNewPlant.pass")}
            value={passNo.toString()}
            onChange={(value) => onPassChanged(value)}
            options={passOption}
          />
        </div>
      </div>
      {passtabs && (
        <>
          <CustomTabs
            tabOptions={passtabs}
            tabChangeHandler={onPassTabSelected}
            value={selectedPass}
          />
          <div>{selectedPassPage}</div>
        </>
      )}
    </>
  );
};

const stageOptions = () => {
  return ["1", "2", "3"];
};

export const StageComponent = ({
  train_id,
  pass_id,
  t,
  trains,
  setTrains,
  setTotalNumberOfElements,
  stageValidationSucessfull,
  setStageValidationSucessfull,
}) => {
  const stageOption = stageOptions();
  pass_id = pass_id - 1;
  const [stage, setStage] = useState(
    trains[train_id].passes[pass_id].stages.length
  );

  const [inputVal, setInputVal] = useState([]);
  const stageNo =
    trains[train_id]?.passes[pass_id]?.stages?.length <= 0
      ? 1
      : trains[train_id]?.passes[pass_id]?.stages?.length;

  useEffect(() => {
    if (Array.isArray(trains)) {
      setInputVal([...trains]);
      setTotalNumberOfElements(getTotalNumber(trains));
    }
  }, [trains, t]);

  useEffect(() => {
    var start = trains[train_id]?.passes[pass_id]?.stages?.length;
    start = start ? start : 1;

    if (start > parseInt(stageNo)) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.passes[pass_id]?.stages.pop(i - 1);
      }
    }
    for (let i = start; i <= parseInt(stageNo); i++) {
      trains[train_id].passes[pass_id].stages.push({ stage_id: i });
    }
    setTrains({ ...trains });
  }, []);

  useEffect(() => {
    var start = trains[train_id]?.passes[pass_id]?.stages?.length;
    start = start ? start : 1;

    if (start > stageNo) {
      for (let i = start; i > parseInt(stageNo); i--) {
        trains[train_id]?.passes[pass_id]?.stages.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(stageNo); i++) {
      trains[train_id].passes[pass_id].stages.push({ stage_id: i });
    }
    setTrains({ ...trains });
  }, [stage, stageNo, t]);

  const onStageChanged = (id, value) => {
    var start = trains[train_id]?.passes[pass_id]?.stages?.length;
    start = start ? start : 1;

    if (start > value) {
      for (let i = start; i > value; i--) {
        trains[train_id]?.passes[pass_id]?.stages.pop(i - 1);
      }
    }
    for (let i = start + 1; i <= parseInt(value); i++) {
      trains[train_id].passes[pass_id].stages.push({ stage_id: i });
    }

    setTrains({ ...trains });
    setStage(value);
  };

  const onStageInputChanged = (stageId, value, name) => {
    if (name === "installation_year") {
      value = value ? moment(value).format("YYYY-MM-DD") : "";
    }
    const trainId = train_id + 1;
    const trainIndex = trains.findIndex(
      (trainItem) => trainItem.train_id === trainId
    );

    if (trainIndex !== -1) {
      const passIndex = trains[trainIndex].passes.findIndex(
        (passItem) => passItem.pass_id === pass_id + 1
      );
      if (passIndex !== -1) {
        trains[trainIndex].passes[passIndex].stages[stageId] = {
          ...trains[trainIndex].passes[passIndex].stages[stageId],
          [name]: value,
        };
      }
    }
    setTrains({ ...trains });
    setInputVal({ ...trains });

    setTotalNumberOfElements(getTotalNumber(trains));
  };

  const getInputVal = (key, index) => {
    if (
      Object.keys(inputVal).length > 0 &&
      inputVal[train_id] &&
      inputVal[train_id].passes[pass_id]
    ) {
      const id = inputVal[train_id].passes[pass_id].stages[index];
      return id && id[key] ? id[key] : "";
    } else return "";
  };

  const getTotalNumber = (trains) => {
    const stageValue = [];

    for (const train of trains) {
      for (const pass of train.passes) {
        for (const stage of pass.stages) {
          if (
            stage.num_pressure_vessels === undefined ||
            stage.num_element_per_pressure_vessel === undefined
          ) {
            stage.num_pressure_vessels = 3;
            stage.num_element_per_pressure_vessel = 6;
            stageValue.push({
              num_pressure_vessels: stage.num_pressure_vessels,
              num_element_per_pressure_vessel:
                stage.num_element_per_pressure_vessel,
            });
          } else {
            stageValue.push({
              num_pressure_vessels: stage.num_pressure_vessels,
              num_element_per_pressure_vessel:
                stage.num_element_per_pressure_vessel,
            });
          }
        }
      }
    }
    return calculateCumulativeSum(stageValue);
  };
  const calculateCumulativeSum = (data) => {
    let cumulativeSum = 0;
    for (const element of data) {
      const numPressureVessels = parseInt(element.num_pressure_vessels);
      const numElementPerPressureVessel = parseInt(
        element.num_element_per_pressure_vessel
      );
      const product = numPressureVessels * numElementPerPressureVessel;
      cumulativeSum += product;
    }
    const sum = isNaN(cumulativeSum) ? "" : cumulativeSum;
    return sum;
  };
  const getErrors = (key, index) => {
    if (
      !stageValidationSucessfull &&
      (trains[train_id].passes[pass_id].stages[index] === undefined ||
        trains[train_id].passes[pass_id].stages[index][key] === undefined ||
        trains[train_id].passes[pass_id].stages[index][key] === "")
    ) {
      return true;
    }
  };

  return (
    <>
      <div className="flex-between description-text outline-box">
        <span className="description-text">
          {t("addNewPlant.noOfstage")}
          <span style={{ color: "red" }}> *</span>
        </span>
        <div className="custom-input-width">
          <Dropdown
            id="no-of-stages"
            placeholder={t("addNewPlant.stage")}
            value={stageNo.toString()}
            onChange={(value) => onStageChanged(pass_id, value)}
            options={stageOption}
          />
        </div>
      </div>
      <div className="flex-between outline-box">
        <div className=" description-text marginTop30 ">
          <div className="padding-top-20">{t("addNewPlant.noOfVessels")}</div>
          <div className="padding-top-20">
            {t("addNewPlant.noOfElementsVessels")}
          </div>
          <div className="padding-top-20">{t("addNewPlant.ro/nfElements")}</div>
          <div className="padding-top-20">
            {t("addNewPlant.installationYear")}
          </div>
        </div>
        <div className="flex-between">
          {Array.from({
            length: trains[train_id].passes[pass_id].stages.length,
          }).map((_, index) => (
            <div className="margin-left-stage stage-Input">
              <div className="teal-text marginBtm20">{`${t(
                "addNewPlant.stage"
              )} ${index + 1}`}</div>
              <div>
                <InputBox
                  key={`${pass_id}num_pressure_vessels${index}`}
                  name="num_pressure_vessels"
                  value={getInputVal("num_pressure_vessels", index)}
                  placeholder={t("addNewPlant.noOfVessels")}
                  onChange={(value, name) =>
                    onStageInputChanged(index, value, name)
                  }
                  validator={TextFieldValidator.NUMBER_ONLY}
                  maxLength={3}
                  errorMsg={
                    getErrors("num_pressure_vessels", index) ||
                    (getInputVal("num_pressure_vessels", index) < 1 ||
                    getInputVal("num_pressure_vessels", index) > 100
                      ? t("addNewPlant.noofPressureVesselsValidation")
                      : "")
                  }
                />
                <InputBox
                  key={`${pass_id}num_element_per_pressure_vessel ${index}`}
                  name="num_element_per_pressure_vessel"
                  value={getInputVal("num_element_per_pressure_vessel", index)}
                  customClass="padding-top-10"
                  placeholder={t("addNewPlant.noOfElementsVesselsPlaceholder")}
                  onChange={(value, name) =>
                    onStageInputChanged(index, value, name)
                  }
                  validator={TextFieldValidator.NUMBER_ONLY}
                  maxLength={3}
                  errorMsg={
                    getErrors("num_element_per_pressure_vessel", index) ||
                    (getInputVal("num_element_per_pressure_vessel", index) <
                      1 ||
                    getInputVal("num_element_per_pressure_vessel", index) > 8
                      ? t("addNewPlant.elementsPerVesselValidation")
                      : "")
                  }
                />
                <InputBox
                  key={`${pass_id}ro_nf_element_used${index}`}
                  name="ro_nf_element_used"
                  value={getInputVal("ro_nf_element_used", index)}
                  customClass=" padding-top-10"
                  placeholder={t("addNewPlant.ro/nfElements")}
                  onChange={(value, name) =>
                    onStageInputChanged(index, value, name)
                  }
                />

                <div className="padding-top-10">
                  <DupontDatePicker
                    id={`${pass_id}installation_year${index}`}
                    selected={
                      getInputVal("installation_year", index) !== ""
                        ? new Date(getInputVal("installation_year", index))
                        : ""
                    }
                    dateFormat={t("ValueStrings.DATE_FORMAT_SMALL")}
                    onChange={(value, name) =>
                      onStageInputChanged(index, value, "installation_year")
                    }
                    startDate={new Date()}
                    maxDate={new Date()}
                    className={"width-fill "}
                    {...DatePickerConfig}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
